exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bgView___1-uPp {\n  background-color: #ffffff;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.content___28QKA {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%;\n}\n.img___25_VY {\n  width: 117px;\n  height: 117px;\n}\n.text___1Y3IW {\n  font-size: 20px;\n  color: #20304b;\n  text-align: center;\n  font-weight: bold;\n}\n.btn___zdu1v {\n  width: 120px;\n  margin-top: 40px;\n}\n.btn___zdu1v span {\n  color: #ffffff !important;\n}\n", ""]);

// exports
exports.locals = {
	"bgView": "bgView___1-uPp",
	"content": "content___28QKA",
	"img": "img___25_VY",
	"text": "text___1Y3IW",
	"btn": "btn___zdu1v"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/routes/author/result/index.less
// module id = 1125
// module chunks = 0